import { render, staticRenderFns } from "./news_events.vue?vue&type=template&id=feabab1e&scoped=true&"
import script from "./news_events.vue?vue&type=script&lang=js&"
export * from "./news_events.vue?vue&type=script&lang=js&"
import style0 from "./news_events.vue?vue&type=style&index=0&id=feabab1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feabab1e",
  null
  
)

export default component.exports